import styled from "styled-components";
import { getBreakpoint } from "../../../../../../../../common-deprecated/themes/common";
import * as Button from "../../../../../../../../common-deprecated/styles/v2/toyota/components/Button";
import { theme } from "../../../../../../../../common-deprecated/styles/v2/toyota/theme/toyotaTheme";

export const Wrapper = styled.div<{ center?: boolean }>`
    display: none;
    flex-wrap: wrap;
    align-items: center;
    justify-content: ${({ center }) => (center ? "center" : "space-between")};
    margin-top: ${theme.space[6]}px;

    ${Button.Primary}, ${Button.Link} {
        margin-top: ${theme.space[3]}px;
        &:not(:last-child) {
            margin-right: ${theme.space[3]}px;
        }

        @media ${getBreakpoint("up", "lg")} {
            margin-top: 0;
        }
    }

    /* on mobile, the step navigation component & mobile footer are always visible and contain the same buttons  */
    @media ${getBreakpoint("up", "lg")} {
        display: flex;
    }
`;
